import React from 'react'

const ProjectPort = ({dataProject}) => {
  return (
    <div className="row  overflow-hidden mainDropFilter"  my-5 id="Projects">
          <div className=" col-12">
            <h1 className=" text-center">
              <span className="pb-2">Projects</span>
            </h1>
            <div className=" p-4 d-flex justify-content-around flex-wrap">
              {dataProject.map((item, index) => (
                <div
                  className="project-card"
                  data-aos-duration="1000"
                  data-aos="fade-left"
                >
                  <img className="project-image" src={item.Image} alt="" />
                  <h3 className="project-title">{item.title}</h3>
                  <p className="project-description">{item.paragrapgh}</p>
                  <div className="project-links">
                    <a
                      href={item.hreflink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.Link}
                    </a>
                    {/* <a href="" target="_blank" rel="noopener noreferrer">
                    Code
                  </a> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
  )
}

export default ProjectPort
